import { render, staticRenderFns } from "./NextInQueue.vue?vue&type=template&id=2b780a60"
import script from "./NextInQueue.vue?vue&type=script&lang=js"
export * from "./NextInQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports